var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreateProfessionalIntroduction } from '@/actions/IntroductionActions';
import { ProfessionalMyPageIntroductionView } from '@/components/pages/mypage/professional/ProfessionalMyPageIntroduction/ProfessionalMyPageIntroductionView';
import { wrapNotifyError } from '@/helpers/action';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { isClient } from '@/utils/resources/auth/authResource';
import { getFullName, getOrganizationName, getPosition, isCanUseProfessionalProffit, isCanUseProfessionalProffitMart, } from '@/utils/resources/profile/profileResource';
import { professionalIntroductionComplete } from '@/utils/router/links';
export const ProfessionalMyPageIntroduction = (props) => {
    const { profile } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const history = useNavigate();
    const { auth } = useTypeSelector((rootState) => ({
        auth: rootState.auth,
    }));
    const user = useMemo(() => {
        var _a;
        return ({
            fullName: getFullName(profile),
            image: (_a = profile.information) === null || _a === void 0 ? void 0 : _a.file,
            isUseProffit: isCanUseProfessionalProffit(profile),
            isUseProffitMart: isCanUseProfessionalProffitMart(profile),
            organizationName: getOrganizationName(profile),
            position: getPosition(profile, isClient(auth)),
        });
    }, [auth, profile]);
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const submitAction = apiCreateProfessionalIntroduction(values);
            yield wrapDispatch(dispatch, submitAction);
            if (!unmountRef.current) {
                history.push(professionalIntroductionComplete());
            }
        }));
    }), [dispatch, history, unmountRef]);
    return _jsx(ProfessionalMyPageIntroductionView, { onSubmit: onSubmit, user: user });
};
